"use client";
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Flex,
  Input,
  Button,
  useMediaQuery,
  IconButton,
} from "@chakra-ui/react";
import { Loader } from "@googlemaps/js-api-loader";
import {
  fetchallBusinessApi,
  getNearbyBusinesses,
} from "../../app/api/businessApi";
import { useSearch } from "../navbar/SearchContext";
import { SearchIcon } from "@chakra-ui/icons";
import API from "@/utils/rolebasenavigation";
import { useRouter } from "next/navigation";
import { sendGAEvent } from "@next/third-parties/google";
import MapAdvertisement from "./mapads";

export interface AdvertisementImage {
  url: string;
  fileId: string;
  _id: string;
}

export interface AdvertisementBusiness {
  _id: string;
  businessname?: string;
  businessdescription?: string;
  slug?: string;
  logo?: {
    url?: string;
  };
}

export interface Advertisement {
  _id: string;
  businessId: AdvertisementBusiness | string;
  type: "promoted" | string;
  startDate: string;
  endDate: string;
  price: number;
  status: "accept" | string;
  ownerId: string;
  images: AdvertisementImage[];
  views: number;
  clicks: number;
  created_at: string;
  updated_at: string;
}
export type Biz = {
  _id?: string;
  businessname?: string;
  businessdescription?: string;
  logo?: { url?: string };
  slug?: string;
  location?: { type?: string; coordinates: [number, number] };
  city?: string;
  streetaddress?: string;
  state?: string;
  pincode?: number | string;
  [k: string]: any;
};
export interface NearbyBusinessResponse {
  nearbyDBBusinesses: Biz[];
  advertisements: Advertisement[];
}

const loader = new Loader({
  apiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY!,
  version: "weekly",
  libraries: ["places", "marker"],
});

const GoogleMapBanner: React.FC = () => {
  const mapRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isSmallerThan480] = useMediaQuery("(max-width: 480px)");

  const { searchName, setSearchName, setSearchTrigger, searchResults } =
    useSearch();
  const [tempName, setTempName] = useState(searchName || "");

  const { navigate } = API();
  const router = useRouter();

  const mapInstanceRef = useRef<google.maps.Map | null>(null);
  const markersRef = useRef<Array<any>>([]);
  const [userLocation, setUserLocation] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const [locationDenied, setLocationDenied] = useState(false);
  const [featuredAds, setFeaturedAds] = useState<Advertisement[]>([]);
  const [showAdvertisement, setShowAdvertisement] = useState(true);
  const [activeAdIndex, setActiveAdIndex] = useState(0);

  useEffect(() => {
    let isMounted = true;
    let watchId: number | null = null;

    const init = async () => {
      if (!navigator.geolocation) {
        setLocationDenied(true);
        return;
      }

      await loader.load();

      const google = window.google;

      watchId = navigator.geolocation.watchPosition(
        (pos) => {
          if (!isMounted) return;

          const loc = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
          setUserLocation(loc);

          // Create map only once
          if (!mapInstanceRef.current) {
            const map = new google.maps.Map(mapRef.current as HTMLElement, {
              center: loc,
              zoom: 16,
              mapId: "MY_NEXTJS_MAPID",
              fullscreenControl: false,
              mapTypeControl: false,
            });

            mapInstanceRef.current = map;

            // User marker
            const userPin = document.createElement("div");

            userPin.innerHTML = `
            <div
              style="
                position:relative;
                width:40px;
                height:60px;
                display:flex;
                flex-direction:column;
                align-items:center;
              "
            >
              <div
                style="
                  width:40px;
                  height:40px;
                  border-radius:50%;
                  overflow:hidden;
                  background:white;
                  border:3px solid #ff3333;
                "
              >
                <img
                  src="/images/logo-png.png"
                  style="
                    width:100%;
                    height:100%;
                    object-fit:cover;
                  "
                />
              />
              </div>

              <div
                style="
                  width:0;
                  height:0;
                  border-left:10px solid transparent;
                  border-right:10px solid transparent;
                  border-top:15px solid #ff3333;
                  margin-top:-2px;
                "
              ></div>
            </div>
          `;

            try {
              const { AdvancedMarkerElement } = google.maps.marker;

              new AdvancedMarkerElement({
                position: loc,
                map,
                content: userPin,
                title: "You are here",
              });
            } catch {
              new google.maps.Marker({
                position: loc,
                map,
                title: "You are here",
              });
            }
          } else {
            // Update map center
            mapInstanceRef.current.setCenter(loc);
          }
        },

        (error) => {
          console.error("Geolocation error:", error.code, error.message);

          setLocationDenied(true);
        },

        {
          enableHighAccuracy: true,
          maximumAge: 60000,
          timeout: 30000,
        },
      );
    };

    init();

    return () => {
      // isMounted = false;

      // if (watchId !== null) {
      //   navigator.geolocation.clearWatch(watchId);
      // }
      //   mapInstanceRef.current = null;

      isMounted = false;
      if (watchId !== null) {
        navigator.geolocation.clearWatch(watchId);
      }
    };
  }, []);
  const clearMarkers = () => {
    markersRef.current.forEach((m) => {
      try {
        m.setMap && m.setMap(null);
      } catch {}
    });
    markersRef.current = [];
  };
  const addMarker = (
    map: google.maps.Map,
    biz: Biz,
    googleAny: any,
    idx?: number,
  ) => {
    if (!biz?.location?.coordinates || biz.location.coordinates.length < 2)
      return;

    const [lng, lat] = biz.location.coordinates;
    const position = { lat, lng };
    const logoUrl = biz.logo?.url || "/logo-png.png";

    const pinEl = document.createElement("div");
    pinEl.innerHTML = `
      <div style="position: relative; width: 35px; height: 50px; display:flex; flex-direction:column; align-items:center;">
        <div style="
          width: 35px;height: 35px;border-radius: 50%;overflow: hidden;
          border: 3px solid #4285F4;background: white;box-shadow: 0 2px 6px rgba(0,0,0,0.15);
        ">
          <img src="${logoUrl}" style="width:100%;height:100%;object-fit:cover;" />
        </div>
        <div style="width:0;height:0;border-left:9px solid transparent;border-right:9px solid transparent;border-top:13px solid #4285F4;margin-top:-3px;"></div>
      </div>
    `;

    let marker: any;
    try {
      const { AdvancedMarkerElement } = googleAny.maps.marker;
      marker = new AdvancedMarkerElement({
        position,
        map,
        content: pinEl,
        title: biz.businessname,
      });
    } catch {
      // fallback to classic marker
      marker = new googleAny.maps.Marker({
        position,
        map,
        title: biz.businessname,
      });
    }

    const infoContent = `
      <div style="max-width:240px;text-align:center;padding:8px;font-family:Arial, sans-serif;">
        <img src="${logoUrl}" style="width:65px;height:65px;border-radius:50%;object-fit:cover;margin-bottom:10px;"/>
        <h3 style="margin:0;font-size:16px;font-weight:600;">${
          biz.businessname || ""
        }</h3>
        <p style="font-size:13px;color:#444;margin-top:6px;">
          ${(biz.businessdescription || "No description")
            .split(" ")
            .slice(0, 12)
            .join(" ")}...
        </p>
      </div>
    `;

    const infowindow = new googleAny.maps.InfoWindow({ content: infoContent });

    if (marker.addListener) {
      marker.addListener("click", () => {
        infowindow.open(map, marker);
        if (biz.slug) setTimeout(() => router.push(biz.slug), 300);
      });
      sendGAEvent("event", "map_pin_click", { page_location: biz.slug });
    } else {
      pinEl.addEventListener("click", () => {
        infowindow.open(map);
        if (biz.slug) setTimeout(() => router.push(biz.slug), 300);
        sendGAEvent("event", "map_pin_click", { page_location: biz.slug });
      });
    }

    markersRef.current.push(marker);
  };

  useEffect(() => {
    const render = async () => {
      const map = mapInstanceRef.current;
      if (!map) return;

      clearMarkers();

      const googleAny = (window as any).google;
      let businessesToShow: Biz[] = [];

      //  If searchResults exist (populated by BusinessList or search flow), use them
      if (Array.isArray(searchResults) && searchResults.length > 0) {
        businessesToShow = searchResults;
      } else if (searchName && searchName.trim()) {
        // If user typed a searchName but searchResults not present, fetch all and filter client-side
        try {
          const allResp = await fetchallBusinessApi();
          const all = Array.isArray(allResp?.businesses)
            ? allResp.businesses
            : [];

          const q = searchName.trim().toLowerCase();

          // match against address field
          businessesToShow = all.filter((b: Biz) => {
            const city = String(b.city || "").toLowerCase();
            const street = String(b.streetaddress || "").toLowerCase();
            const state = String(b.state || "").toLowerCase();
            const pin = String(b.pincode || "").toLowerCase();
            const name = String(b.businessname || "").toLowerCase();

            return (
              city.includes(q) ||
              street.includes(q) ||
              state.includes(q) ||
              pin.includes(q) ||
              name.includes(q)
            );
          });
        } catch (err) {
          console.error(
            "Error fetching all businesses for client-side filter",
            err,
          );
        }
      } else if (userLocation) {
        // No search show nearby businesses
        try {
          const res = await getNearbyBusinesses(
            userLocation.lat,
            userLocation.lng,
          );
          businessesToShow = res?.nearbyDBBusinesses || [];
          const ads: Advertisement[] = res.advertisements || [];
          setFeaturedAds(res?.advertisements || []);
          if (ads.length > 0) {
            const randomIndex = Math.floor(Math.random() * ads.length);

            setActiveAdIndex(randomIndex);
          }
        } catch (err) {
          console.error("Error fetching nearby businesses", err);
        }
      } else {
        //optionally fetch all and show some
        try {
          const allResp = await fetchallBusinessApi();
          businessesToShow = Array.isArray(allResp?.businesses)
            ? allResp.businesses
            : [];
        } catch (err) {
          console.error("Error fetching fallback businesses", err);
        }
      }

      // center map on first result if any search-related results
      if (businessesToShow.length > 0) {
        const first = businessesToShow[0];
        if (first?.location?.coordinates?.length === 2) {
          const [lng, lat] = first.location.coordinates;
          map.setCenter({ lat, lng });
          map.setZoom(14);
        }
      }

      // add markers
      businessesToShow.forEach((biz, idx) =>
        addMarker(map, biz, googleAny, idx),
      );
    };

    render();
    // include dependencies that should re-render markers
  }, [mapInstanceRef.current, searchResults, searchName, userLocation]);

  //Handle search button / clear

  const handleSearch = () => {
    if (!tempName.trim()) return;
    setSearchName(tempName.trim());
    setSearchTrigger(true);
  };

  const handleClear = () => {
    setTempName("");
    setSearchName("");
    setSearchTrigger(true);
  };

  useEffect(() => {
    if (featuredAds.length <= 1) {
      return;
    }

    const interval = setInterval(() => {
      setActiveAdIndex((currentIndex) => {
        let randomIndex = Math.floor(Math.random() * featuredAds.length);

        // Don't show the same ad twice in a row
        while (randomIndex === currentIndex && featuredAds.length > 1) {
          randomIndex = Math.floor(Math.random() * featuredAds.length);
        }

        return randomIndex;
      });
    }, 5000); // change every 5 seconds

    return () => {
      clearInterval(interval);
    };
  }, [featuredAds]);

  const handleAdvertisementClick = (slug: string) => {
    router.push(`/${slug}`);
  };

  return (
    <Box position="relative" height="500px" width="100%" mt={0} p={0} pt="55px">
      {/* Banner when Location is OFF */}
      {locationDenied && (
        <Box
          position="absolute"
          top="70px"
          left="50%"
          transform="translateX(-50%)"
          zIndex={30}
          bg="white"
          p={4}
          px={5}
          borderRadius="lg"
          boxShadow="md"
          border="1px solid #e2e8f0"
          display="flex"
          alignItems="center"
          gap={3}
        >
          <Box fontWeight="600">Enable your location for nearby results</Box>
          <Button
            size="sm"
            colorScheme="blue"
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </Box>
      )}

      {/* Mobile search bar */}
      {isSmallerThan480 && (
        <Flex
          position="absolute"
          top="60px"
          left="50%"
          transform="translateX(-50%)"
          zIndex={20}
          bg="white"
          p={2}
          borderRadius="md"
          boxShadow="md"
          gap={2}
          wrap="wrap"
          justify="center"
          align="center"
          w="90%"
        >
          <Input
            placeholder="Search area (e.g., Swargate)"
            value={tempName}
            onChange={(e) => setTempName(e.target.value)}
            size="sm"
            flex="1"
            ref={inputRef}
          />
          <IconButton
            size="sm"
            bg="blue.500"
            color="white"
            aria-label="Search"
            icon={<SearchIcon />}
            onClick={handleSearch}
            _hover={{ bg: "blue.300" }}
          />
          <Button size="sm" variant="outline" onClick={handleClear}>
            Clear
          </Button>
        </Flex>
      )}

      {/* GOOGLE MAP */}
      <Box position="relative" height="100%" width="100%">
        <div
          ref={mapRef}
          style={{
            height: "100%",
            width: "100%",
          }}
        />

        {showAdvertisement && featuredAds.length > 0 && (
          <MapAdvertisement
            ad={featuredAds[activeAdIndex] || featuredAds[0]}
            onClick={handleAdvertisementClick}
            onClose={() => setShowAdvertisement(false)}
          />
        )}
      </Box>
    </Box>
  );
};

export default GoogleMapBanner;
